/* eslint-disable @next/next/next-script-for-ga */
import Head from 'next/head';
import React from 'react';

import { Layout } from '@/components/common';
import { SERVER_URL } from '@/constants/index';
import WidgetWrapper from '@/components/widget-wrapper/WidgetWrapper';
import { homePageSchema } from '@/constants/schema';

export default React.memo(function Home({ data }) {
  const parsedData = JSON.parse(data);
  return (
    <Layout
      navbar={parsedData?.menu}
      footer={parsedData?.footer}
      metadata={parsedData?.metadata}
      breadcrumbs={parsedData?.breadcrumbs}
      appDownload={parsedData?.app_download_widget}
    >
      <Head>
        <title>{parsedData?.metadata?.title || parsedData?.name}</title>
        {parsedData?.metadata?.description && (
          <meta
            name='description'
            content={parsedData?.metadata?.description}
          />
        )}
        <meta
          name='keywords'
          content={
            parsedData?.metadata?.keywords ||
            parsedData?.metadata?.title ||
            'Bakcell'
          }
        />
        <script
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(homePageSchema),
          }}
          type='application/ld+json'
        />
      </Head>
      <WidgetWrapper
        data-testid='widget-wrapper'
        widgets={parsedData?.widgets}
      />
    </Layout>
  );
});

export const getServerSideProps = async ({ locale }) => {
  const response = await fetch(`${SERVER_URL}/pages/home/`, {
    headers: {
      'Accept-Language': locale,
    },
  });
  const data = await response.text();

  return {
    props: {
      data,
    },
  };
};
